import React from 'react';
import { Card, Descriptions, Typography, Button, Space, Tag, Spin } from 'antd';
import { EditOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useDevice } from '@/hooks/useDevices';

const { Title } = Typography;

const DeviceDetail: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: device, isLoading } = useDevice(id || '');

  if (isLoading) {
    return <Spin size="large" style={{ display: 'flex', justifyContent: 'center', marginTop: 100 }} />;
  }

  if (!device) {
    return <div>Dispositivo não encontrado</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Space>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/devices')} />
          <Title level={4} style={{ margin: 0 }}>Detalhes do Dispositivo</Title>
        </Space>
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={() => navigate(`/devices/${id}/edit`)}
        >
          Editar
        </Button>
      </div>

      <Card>
        <Descriptions bordered column={{ xs: 1, sm: 2, lg: 3 }}>
          <Descriptions.Item label="Hostname">{device.hostname}</Descriptions.Item>
          <Descriptions.Item label="ID RustDesk">{device.rustdesk_id}</Descriptions.Item>
          <Descriptions.Item label="Empresa">{device.company_name}</Descriptions.Item>
          <Descriptions.Item label="Sistema">
            <Tag color={
              device.os_type === 'windows' ? 'blue' :
              device.os_type === 'macos' ? 'purple' : 'green'
            }>
              {device.os_type === 'windows' ? 'Windows' :
               device.os_type === 'macos' ? 'macOS' : 'Linux'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Versão">{device.os_version || '-'}</Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={
              device.status === 'ONLINE' ? 'green' :
              device.status === 'OFFLINE' ? 'red' : 'orange'
            }>
              {device.status === 'ONLINE' ? 'Online' :
               device.status === 'OFFLINE' ? 'Offline' : 'Manutenção'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="IP">{device.ip_address || '-'}</Descriptions.Item>
          <Descriptions.Item label="MAC">{device.mac_address || '-'}</Descriptions.Item>
          <Descriptions.Item label="Último Visto">
            {device.last_seen ? new Date(device.last_seen).toLocaleString('pt-BR') : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Notas" span={2}>{device.notes || '-'}</Descriptions.Item>
          <Descriptions.Item label="Criado em">
            {new Date(device.registered_at).toLocaleString('pt-BR')}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </div>
  );
};

export default DeviceDetail;
